// eslint-disable-next-line max-len
const remToPixels = remString => parseFloat(remString) * parseFloat(getComputedStyle(document.documentElement).fontSize);

export { remToPixels as r };
//# sourceMappingURL=remToPixels-BA_JPFGh-BA_JPFGh.js.map
